module.exports = __webpack_public_path__ + "static/media/BrightBee_Platform-Screens-3.a66193e9.png";